import { Trans, useTranslation } from "react-i18next";
import styled, { css } from "styled-components";
import i18n from "../../i18n";
import { isRTL } from "../../utils/locale";

interface IChipStatus {
  status: string;
  daysLeft: number;
}

const ChipGamedayCounter = styled.div<IChipStatus>`
  flex: 1 250px;
  display: flex;
  gap: ${({ theme }) => theme.space[3]};
  align-self: center;
  align-items: center;
  justify-content: center;
  padding: ${(props) =>
    props.status === "active" || props.status === "played"
      ? "1.5rem 1rem"
      : "0.7rem 1rem"};
  border-radius: ${(props) => props.theme.radii[0]};
  background-color: ${(props) =>
    props.status === "active" ? props.theme.colors.success : "lightGrey"};
  font-weight: 600;
  text-transform: capitalize;
  line-height: 1;
`;

const GamedayCounterString = styled.h3`
  text-align: center;
  text-transform: capitalize;
  margin: 0;
`;

const GamedayCounterNumber = styled.div`
  align-self: center;
  font-family: ${(theme) => theme.theme.fonts.action};
  font-style: italic;
  font-size: ${(props) => props.theme.fontSizes[4]};
  font-weight: 600;
`;

const FinalGamedayCounterString = styled(GamedayCounterNumber)`
  ${
    isRTL(i18n.language)
      ? css`
          font-size: ${(props) => props.theme.fontSizes[2]};
          padding: 7px 0;
        `
      : css`
          font-size: ${(props) => props.theme.fontSizes[4]};
        `
  }
`;

const ChipStatus = ({ status, daysLeft }: IChipStatus) => {
  const { t } = useTranslation();
  if (status === "active") {
    return (
      <ChipGamedayCounter status={status} daysLeft={daysLeft}>
        {t("chipStatus.active", "active")}
      </ChipGamedayCounter>
    );
  }
  if (status === "played") {
    return (
      <ChipGamedayCounter status={status} daysLeft={daysLeft}>
        {t("chipStatus.unavailable", "unavailable until next GW")}
      </ChipGamedayCounter>
    );
  }
  if (daysLeft < 2) {
    return (
      <ChipGamedayCounter status={status} daysLeft={daysLeft}>
        <FinalGamedayCounterString>
          {t("chipStatus.last", "Final Gameday to use")}
        </FinalGamedayCounterString>
      </ChipGamedayCounter>
    );
  }
  return (
    <ChipGamedayCounter status={status} daysLeft={daysLeft}>
      <Trans
        i18nKey="chipStatus.remaining"
        values={{ daysLeft }}
        defaults="<0>Gamedays remaining</0><1>{{daysLeft}}</1>"
        components={[<GamedayCounterString />, <GamedayCounterNumber />]}
      />
    </ChipGamedayCounter>
  );
};

export default ChipStatus;
